import { FormattedMessage } from 'react-intl';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { useSellerFormattedDate } from '../../../../../../hooks/use-datetime-formats';

import { messages } from '../messages';

const LastAuthDateColumn = ({ row }) => {
  const { lastAuthDateUtc } = row.original;
  const displayDate = useSellerFormattedDate(lastAuthDateUtc);

  return (
    <FlexColumn>
      <Text textType={TextType.Paragraph} value={displayDate} />
    </FlexColumn>
  );
};

export const createLastAuthDateColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'lastAuthDateUtc',
  Header: (
    <div>
      <FormattedMessage {...messages.columnLastAuthDate} />
    </div>
  ),
  Cell: LastAuthDateColumn,
  width: 2,
});
